import { useState } from 'react';
import { ProposalService } from '../../../services';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import Modal from '../../Modal';
import FormMotivoRecusa from '../Action2/FormMotivoRecusa';
import FormSelectedPayment from './FormSelectedPayment';
import HelperDate from '../../../helpers/HelperDate';

interface IProp {
  proposal: any;
  statusActual: any;
}
const Action6 = ({ proposal, statusActual }: IProp) => {
  const [isLoad, setIsLoad] = useState<boolean>(false);
  function handleClick(aceito: boolean) {
    if (aceito) {
      Modal.show({
        title: "Proposta",
        body: <FormSelectedPayment proposal={proposal} statusActual={statusActual} ProposalContract={ProposalContract} />,
        showCancel: false,
        showConfirm: false,
        callBack: () => ProposalContract(true, null, null, null, null, null, null),
        cancelText: "Não",
        confirmText: "Sim"
      });
    } else {
      Modal.show({
        title: "Proposta",
        body: <FormMotivoRecusa onConfirm={ProposalContract} />,
        showCancel: true,
        showConfirm: false // confirm agora será controlado dentro do form
      });
    }
  }
  function ProposalContract(aceito: boolean, motivo?: string | null, paymentMethodSave?: number | null, paymentConditionSave?: string | null, paymentObservation?: string | null, birthDate?: string | null, maritalStatus?: number | null, fullNameOfResponsible?: string | null, documentOfResponsible?: string | null) {
    setIsLoad(true);
    console.log( 'birthDate', birthDate );
    const request = {
      id: proposal.id,
      aceito: aceito,
      motivo: aceito ? 0 : motivo || "0",
      paymentMethodSave,
      paymentConditionSave,
      paymentObservation,
      birthDate: birthDate ? HelperDate.convertFormatDate(birthDate ?? '', "DD/MM/YYYY", "YYYY-MM-DD") : null,
      maritalStatus: maritalStatus ?? null,
      fullNameOfResponsible: fullNameOfResponsible ?? null,
      documentOfResponsible: documentOfResponsible ?? null
    };
    ProposalService.postProposalContract(request)
      .then(() => window.location.reload())
      .catch((error) => {
        setIsLoad(false);
        Modal.show({
          title: "Erro ao enviar proposta",
          body: Modal.getErrorMessage(error, request),
          showCancel: true,
          showConfirm: false,
          onCancelText: "Fechar"
        });
      });
  }
  return (
    <>
      {
        isLoad && <LoadingSpinner />
      }
      {
        (proposal.idProposalType === 1 && statusActual.idProposalStatus === 6) ?
          <>
            {
              proposal.proposalFile ?
                <a href={`${proposal.proposalFile}`} download target="_blank" style={{ marginBottom: 15 }} className='btn btn-outline-primary ms-auto' rel="noopener noreferrer">Abrir Proposta Readequada</a>
                : <p>- Sem arquivo de Readequação</p>
            }
          </>
          : <></>
      }

      <button className='btn btn-primary btnForm d-block minWidth200' onClick={() => handleClick(true)}>Aceito</button>
      <button className='btn btn-danger mt-2 d-block minWidth200' onClick={() => handleClick(false)}>Recusar Proposta</button>
    </>
  )
};

export default Action6;
